module.exports = __webpack_public_path__ + "assets/cbc8aa2fc2a4923bae8357843773d236.png";